// Video modal state

// Initial state
const state = () => ({
  open: false,
  type: '',    // video type (e.g., youtube)
  data: {}     // data needed to play the video for its type (e.g., youtube needs a video id)
});

// Getters
const getters = {
  open: (state, getters, rootState) => {
    return state.open;
  },
  type: (state, getters, rootState) => {
    return state.type;
  },
  data: (state, getters, rootState) => {
    return state.data;
  },
};

// Actions
const actions = {
  open({ commit, state }) {
    commit('setOpen', true);
  },
  close({ commit, state }) {
    commit('setOpen', false);
  },
  setVideoInfo({ commit, state }, { type, data }) {
    commit('setVideoInfo', {
      type,
      data
    })
  }
};

// Mutations
const mutations = {
  setOpen(state, open) {
    state.open = open;
  },
  setVideoInfo(state, { type, data }) {
    state.type = type,
    state.data = data
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}